import { render, staticRenderFns } from "./PedidoMayoreoViewComponent.vue?vue&type=template&id=af672ab8&"
import script from "./PedidoMayoreoViewComponent.vue?vue&type=script&lang=js&"
export * from "./PedidoMayoreoViewComponent.vue?vue&type=script&lang=js&"
import style0 from "./PedidoMayoreoViewComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports